import React from 'react';
import { SearchField } from './OrderSearch';
import { SelectedOrder } from './SelectedOrder';
import { Grid } from '@mui/material';

export const OrderSection = props => (
  <Grid item xs={4}>
    <Grid container spacing={2} direction="column">
      <Grid item>
        <SearchField {...props} />
      </Grid>
      <Grid item>
        <SelectedOrder />
      </Grid>
    </Grid>
  </Grid>
);
